import classNames from "classnames";
import { AppAvatar } from "@/shared/Components";
import { handleFullName } from "@/shared/utils/handle-contacts-null";
import { useRuntimeImage } from "@/entities/runtime-image";
import type { Person } from "@/services/api";
import type { FC, HTMLAttributes } from "react";
import type { MaybeType } from "@/shared/types";
import styles from "./styles.module.scss";

export type ContactsMobileListItemProps = {
  person: Person;
  connectedAs?: string;
  additionalInfo?: string;
  style?: HTMLAttributes<HTMLDivElement>["style"];
  onClick?: (person: Person) => void;
  handleOpenModal?: () => void;
  swipedPerson?: MaybeType<string>;
};

export const ContactsMobileListItem: FC<ContactsMobileListItemProps> = ({
  person,
  additionalInfo,
  connectedAs,
  onClick = () => "",
  swipedPerson,
}) => {
  const { getRuntimeImageURL } = useRuntimeImage();

  return (
    <div
      className={classNames(styles["contacts-list-item"], {
        [styles.swiped]: swipedPerson === person.id,
      })}
      onClick={() => onClick(person)}
    >
      <div className={styles["main-content"]}>
        <AppAvatar
          image={getRuntimeImageURL({ fileId: person.avatarFile?.fileId ?? "" })}
          name={handleFullName(person?.firstName, person?.lastName)}
        />
        <div className={styles["contacts-list-item-info"]}>
          <div className={styles["contacts-list-item-group"]}>{person.group}</div>
          <div className={styles["contacts-list-item-name"]}>
            {handleFullName(person?.firstName, person?.lastName)}
          </div>
          <div className={styles["contacts-list-item-title"]}>{person.title}</div>
        </div>
      </div>
      {(additionalInfo || connectedAs) && (
        <div className={styles["sub-info"]}>
          <div className={styles["connected-as"]}>{connectedAs}</div>
          <div className={styles["additional-info"]}>{additionalInfo}</div>
        </div>
      )}
    </div>
  );
};
